import { Broadcast } from '.'

export function broadcastToParent<E extends string, T = any>(
  config: Broadcast<E, T>
) {
  window?.parent?.postMessage(JSON.stringify(config), '*')
}
